// Dua Collection — Hisn al-Muslim (Fortress of the Muslim) curated selection
// Categories with duas: Arabic, transliteration, translation, source

const DUA_CATEGORIES = [
  {
    id: "morning",
    name: "Morning Adhkar",
    nameAr: "أذكار الصباح",
    icon: "🌅",
    color: { dark: "#ffb300", light: "#b87008" },
    duas: [
      {
        arabic: "أَصْبَحْنَا وَأَصْبَحَ الْمُلْكُ لِلَّهِ وَالْحَمْدُ لِلَّهِ لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
        translit: "Asbahna wa asbahal-mulku lillah, walhamdu lillah, la ilaha illallahu wahdahu la shareeka lah, lahul-mulku wa lahul-hamdu wa huwa 'ala kulli shay'in qadeer.",
        translation: "We have reached the morning and at this very time the dominion belongs to Allah. All praise is for Allah. None has the right to be worshipped except Allah, alone, without partner. To Him belongs the dominion and to Him is all praise, and He is over all things capable.",
        source: "Muslim 4/2088",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ بِكَ أَصْبَحْنَا وَبِكَ أَمْسَيْنَا وَبِكَ نَحْيَا وَبِكَ نَمُوتُ وَإِلَيْكَ النُّشُورُ",
        translit: "Allahumma bika asbahna wa bika amsayna wa bika nahya wa bika namootu wa ilaykan-nushoor.",
        translation: "O Allah, by Your leave we have reached the morning and by Your leave we have reached the evening. By Your leave we live and by Your leave we die, and unto You is the resurrection.",
        source: "Tirmidhi 5/466",
        repeat: 1,
      },
      {
        arabic: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ",
        translit: "Subhanallahi wa bihamdihi.",
        translation: "Glory is to Allah and praise is to Him.",
        source: "Muslim 4/2071",
        repeat: 100,
      },
    ],
  },
  {
    id: "evening",
    name: "Evening Adhkar",
    nameAr: "أذكار المساء",
    icon: "🌙",
    color: { dark: "#b4a0ff", light: "#643cc8" },
    duas: [
      {
        arabic: "أَمْسَيْنَا وَأَمْسَى الْمُلْكُ لِلَّهِ وَالْحَمْدُ لِلَّهِ لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
        translit: "Amsayna wa amsal-mulku lillah, walhamdu lillah, la ilaha illallahu wahdahu la shareeka lah, lahul-mulku wa lahul-hamdu wa huwa 'ala kulli shay'in qadeer.",
        translation: "We have reached the evening and at this very time the dominion belongs to Allah. All praise is for Allah. None has the right to be worshipped except Allah, alone, without partner. To Him belongs the dominion and to Him is all praise, and He is over all things capable.",
        source: "Muslim 4/2088",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ بِكَ أَمْسَيْنَا وَبِكَ أَصْبَحْنَا وَبِكَ نَحْيَا وَبِكَ نَمُوتُ وَإِلَيْكَ الْمَصِيرُ",
        translit: "Allahumma bika amsayna wa bika asbahna wa bika nahya wa bika namootu wa ilaykal-maseer.",
        translation: "O Allah, by Your leave we have reached the evening and by Your leave we have reached the morning. By Your leave we live and by Your leave we die, and unto You is the return.",
        source: "Tirmidhi 5/466",
        repeat: 1,
      },
      {
        arabic: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ",
        translit: "A'oodhu bi kalimatillahit-tammaati min sharri ma khalaq.",
        translation: "I seek refuge in the perfect words of Allah from the evil of what He has created.",
        source: "Muslim 4/2081",
        repeat: 3,
      },
    ],
  },
  {
    id: "sleep",
    name: "Before Sleep",
    nameAr: "أذكار النوم",
    icon: "😴",
    color: { dark: "#64a0ff", light: "#3264dc" },
    duas: [
      {
        arabic: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
        translit: "Bismikallahumma amootu wa ahya.",
        translation: "In Your name, O Allah, I die and I live.",
        source: "Bukhari 11/113",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ إِنَّكَ خَلَقْتَ نَفْسِي وَأَنْتَ تَوَفَّاهَا لَكَ مَمَاتُهَا وَمَحْيَاهَا إِنْ أَحْيَيْتَهَا فَاحْفَظْهَا وَإِنْ أَمَتَّهَا فَاغْفِرْ لَهَا اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ",
        translit: "Allahumma innaka khalaqta nafsee wa anta tawaffaha, laka mamatuha wa mahyaha. In ahyaytaha fahfadh-ha, wa in amattaha faghfir laha. Allahumma inni as'alukal-'afiyah.",
        translation: "O Allah, You have created my soul and You take it back. Unto You is its death and its life. If You give it life, then protect it; and if You cause it to die, then forgive it. O Allah, I ask You for well-being.",
        source: "Muslim 4/2083",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ قِنِي عَذَابَكَ يَوْمَ تَبْعَثُ عِبَادَكَ",
        translit: "Allahumma qinee 'adhabaka yawma tab'athu 'ibadak.",
        translation: "O Allah, protect me from Your punishment on the Day You resurrect Your servants.",
        source: "Abu Dawud 4/311",
        repeat: 3,
      },
    ],
  },
  {
    id: "wakeup",
    name: "Waking Up",
    nameAr: "دعاء الاستيقاظ",
    icon: "🌤",
    color: { dark: "#00c9a7", light: "#009e87" },
    duas: [
      {
        arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
        translit: "Alhamdu lillahil-ladhee ahyana ba'da ma amatana wa ilayhin-nushoor.",
        translation: "All praise is for Allah who gave us life after having taken it from us, and unto Him is the resurrection.",
        source: "Bukhari 11/113",
        repeat: 1,
      },
    ],
  },
  {
    id: "travel",
    name: "Travel",
    nameAr: "أدعية السفر",
    icon: "✈️",
    color: { dark: "#ff8a65", light: "#d84315" },
    duas: [
      {
        arabic: "اللَّهُ أَكْبَرُ اللَّهُ أَكْبَرُ اللَّهُ أَكْبَرُ سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ",
        translit: "Allahu Akbar, Allahu Akbar, Allahu Akbar. Subhanal-ladhee sakh-khara lana hadha wa ma kunna lahu muqrineen, wa inna ila Rabbina lamunqaliboon.",
        translation: "Allah is the Greatest, Allah is the Greatest, Allah is the Greatest. Glory is to Him Who has provided this for us, though we could never have had it by our efforts. Surely, unto our Lord we are returning.",
        source: "Muslim 2/978",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ إِنَّا نَسْأَلُكَ فِي سَفَرِنَا هَذَا الْبِرَّ وَالتَّقْوَى وَمِنَ الْعَمَلِ مَا تَرْضَى اللَّهُمَّ هَوِّنْ عَلَيْنَا سَفَرَنَا هَذَا وَاطْوِ عَنَّا بُعْدَهُ اللَّهُمَّ أَنْتَ الصَّاحِبُ فِي السَّفَرِ وَالْخَلِيفَةُ فِي الْأَهْلِ",
        translit: "Allahumma inna nas'aluka fee safarina hadhal-birra wat-taqwa wa minal-'amali ma tarda. Allahumma hawwin 'alayna safarana hadha watwi 'anna bu'dah. Allahumma antas-sahibu fis-safari wal-khaleefatu fil-ahl.",
        translation: "O Allah, we ask You for righteousness and piety in this journey of ours, and we ask You for deeds which please You. O Allah, ease our journey and let us cover its distance quickly. O Allah, You are the Companion on the journey and the Successor over the family.",
        source: "Muslim 2/978",
        repeat: 1,
      },
    ],
  },
  {
    id: "food",
    name: "Food & Drink",
    nameAr: "أدعية الطعام",
    icon: "🍽",
    color: { dark: "#66bb6a", light: "#2e7d32" },
    duas: [
      {
        arabic: "بِسْمِ اللَّهِ",
        translit: "Bismillah.",
        translation: "In the name of Allah.",
        source: "Abu Dawud 3/347",
        repeat: 1,
      },
      {
        arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنِي هَذَا وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلَا قُوَّةٍ",
        translit: "Alhamdu lillahil-ladhee at'amanee hadha wa razaqaneehi min ghayri hawlin minnee wa la quwwah.",
        translation: "All praise is for Allah Who has fed me this and provided it for me without any effort or power on my part.",
        source: "Tirmidhi, Abu Dawud",
        repeat: 1,
      },
    ],
  },
  {
    id: "masjid",
    name: "Entering & Leaving Masjid",
    nameAr: "دعاء المسجد",
    icon: "🕌",
    color: { dark: "#26c6da", light: "#00838f" },
    duas: [
      {
        arabic: "اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ",
        translit: "Allahumma-ftah lee abwaba rahmatik.",
        translation: "O Allah, open the gates of Your mercy for me.",
        source: "Muslim 1/494",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ",
        translit: "Allahumma innee as'aluka min fadlik.",
        translation: "O Allah, I ask You from Your favour.",
        source: "Muslim 1/494",
        repeat: 1,
      },
    ],
  },
  {
    id: "anxiety",
    name: "Anxiety & Distress",
    nameAr: "أدعية الهم والحزن",
    icon: "🤲",
    color: { dark: "#ef9a9a", light: "#c62828" },
    duas: [
      {
        arabic: "لَا إِلَهَ إِلَّا اللَّهُ الْعَظِيمُ الْحَلِيمُ لَا إِلَهَ إِلَّا اللَّهُ رَبُّ الْعَرْشِ الْعَظِيمِ لَا إِلَهَ إِلَّا اللَّهُ رَبُّ السَّمَاوَاتِ وَرَبُّ الْأَرْضِ وَرَبُّ الْعَرْشِ الْكَرِيمِ",
        translit: "La ilaha illallahul-'Adheemul-Haleem. La ilaha illallahu Rabbul-'Arshil-'Adheem. La ilaha illallahu Rabbus-samawati wa Rabbul-ardi wa Rabbul-'Arshil-Kareem.",
        translation: "None has the right to be worshipped except Allah, the Magnificent, the Forbearing. None has the right to be worshipped except Allah, Lord of the Magnificent Throne. None has the right to be worshipped except Allah, Lord of the heavens, Lord of the earth, and Lord of the Noble Throne.",
        source: "Bukhari 8/154, Muslim 4/2092",
        repeat: 1,
      },
      {
        arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ وَأَعُوذُ بِكَ مِنَ الْعَجْزِ وَالْكَسَلِ وَأَعُوذُ بِكَ مِنَ الْجُبْنِ وَالْبُخْلِ وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ وَقَهْرِ الرِّجَالِ",
        translit: "Allahumma innee a'oodhu bika minal-hammi wal-hazan, wa a'oodhu bika minal-'ajzi wal-kasal, wa a'oodhu bika minal-jubni wal-bukhl, wa a'oodhu bika min ghalabatid-dayni wa qahrir-rijal.",
        translation: "O Allah, I seek refuge in You from worry and grief, from helplessness and laziness, from cowardice and stinginess, and from the burden of debts and from being overpowered by men.",
        source: "Bukhari 7/158",
        repeat: 1,
      },
      {
        arabic: "حَسْبُنَا اللَّهُ وَنِعْمَ الْوَكِيلُ",
        translit: "Hasbunallahu wa ni'mal-wakeel.",
        translation: "Allah is sufficient for us, and He is the best disposer of affairs.",
        source: "Bukhari 5/172",
        repeat: 7,
      },
    ],
  },
  {
    id: "forgiveness",
    name: "Seeking Forgiveness",
    nameAr: "أدعية الاستغفار",
    icon: "💧",
    color: { dark: "#80cbc4", light: "#00695c" },
    duas: [
      {
        arabic: "أَسْتَغْفِرُ اللَّهَ الْعَظِيمَ الَّذِي لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ وَأَتُوبُ إِلَيْهِ",
        translit: "Astaghfirullahul-'Adheemal-ladhee la ilaha illa Huwal-Hayyul-Qayyoomu wa atoobu ilayh.",
        translation: "I seek the forgiveness of Allah the Magnificent, Whom there is none worthy of worship except Him, the Living, the Self-Sustaining, and I turn to Him in repentance.",
        source: "Abu Dawud 2/85, Tirmidhi 5/569",
        repeat: 3,
      },
      {
        arabic: "اللَّهُمَّ أَنْتَ رَبِّي لَا إِلَهَ إِلَّا أَنْتَ خَلَقْتَنِي وَأَنَا عَبْدُكَ وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ وَأَبُوءُ بِذَنْبِي فَاغْفِرْ لِي فَإِنَّهُ لَا يَغْفِرُ الذُّنُوبَ إِلَّا أَنْتَ",
        translit: "Allahumma anta Rabbee la ilaha illa anta, khalaqtanee wa ana 'abduka, wa ana 'ala 'ahdika wa wa'dika mastata't, a'oodhu bika min sharri ma sana'tu, aboo'u laka bi ni'matika 'alayya, wa aboo'u bidhanbee, faghfir lee fa innahu la yaghfirudh-dhunooba illa anta.",
        translation: "O Allah, You are my Lord, there is none worthy of worship except You. You created me and I am Your servant, and I abide by Your covenant and promise as best I can. I seek refuge in You from the evil of what I have done. I acknowledge Your favour upon me, and I acknowledge my sin, so forgive me, for none forgives sins except You.",
        source: "Bukhari 7/150 (Sayyid al-Istighfar)",
        repeat: 1,
      },
    ],
  },
  {
    id: "protection",
    name: "Protection",
    nameAr: "أدعية الحماية",
    icon: "🛡",
    color: { dark: "#ffd54f", light: "#f57f17" },
    duas: [
      {
        arabic: "بِسْمِ اللَّهِ الَّذِي لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ",
        translit: "Bismillahil-ladhee la yadurru ma'asmihi shay'un fil-ardi wa la fis-sama'i wa Huwas-Samee'ul-'Aleem.",
        translation: "In the name of Allah, with Whose name nothing is harmed on earth nor in the heavens, and He is the All-Hearing, All-Knowing.",
        source: "Abu Dawud 4/323, Tirmidhi 5/465",
        repeat: 3,
      },
      {
        arabic: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ",
        translit: "A'oodhu bi kalimatillahit-tammaati min sharri ma khalaq.",
        translation: "I seek refuge in the perfect words of Allah from the evil of what He has created.",
        source: "Muslim 4/2081",
        repeat: 3,
      },
    ],
  },
  {
    id: "rain",
    name: "During Rain",
    nameAr: "دعاء المطر",
    icon: "🌧",
    color: { dark: "#90caf9", light: "#1565c0" },
    duas: [
      {
        arabic: "اللَّهُمَّ صَيِّبًا نَافِعًا",
        translit: "Allahumma sayyiban nafi'a.",
        translation: "O Allah, let it be a beneficial rain.",
        source: "Bukhari 2/518",
        repeat: 1,
      },
    ],
  },
  {
    id: "parents",
    name: "For Parents",
    nameAr: "دعاء للوالدين",
    icon: "❤️",
    color: { dark: "#f48fb1", light: "#ad1457" },
    duas: [
      {
        arabic: "رَبِّ اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ",
        translit: "Rabbighfir lee wa liwalidayya wa lil-mu'mineena yawma yaqoomul-hisab.",
        translation: "Our Lord, forgive me and my parents and the believers the Day the account is established.",
        source: "Quran 14:41",
        repeat: 1,
      },
      {
        arabic: "رَبِّ ارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا",
        translit: "Rabbirhamhuma kama rabbayanee sagheera.",
        translation: "My Lord, have mercy upon them as they brought me up when I was small.",
        source: "Quran 17:24",
        repeat: 1,
      },
    ],
  },
];

export default DUA_CATEGORIES;
